import React from "react";

export const VendorTableConfig = [
    {
        title: 'Vendor', dataIndex: 'name', key: 'name',
    },
    {
        title: 'Point of Contact', dataIndex: 'point_of_contact', key: 'point_of_contact',
    },
    {
        title: 'Users', dataIndex: 'users', key: 'email',
        render: (users) => {
            return (
                <div>{users.length}</div>
            )
        }
    },
]